import apiClient from '../../../common/functions/api_axios_instance.function';
import { notify } from '../../../common/functions/react-toastify.function';

export const approveAssignmentRequest = async (requestId, review_comment = '') => {
  try {
    const response = await apiClient.post(
      `/systemInvoiceRoleManagement/requests/${requestId}/approve`,

      {
        review_comment,
      }
    );
    const message = response?.data?.message || 'Assignment change approved';
    notify('success', message);
    return { success: true, data: response.data };
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || error.response?.data?.error || 'Failed to approve request';
    notify('error', errorMessage);
    return { success: false, error: errorMessage };
  }
};
